import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'

import user from './module/user'
import app from './module/app'
import websocket from "./module/websocket"
import cacheData from "./module/cacheData"
import clickData from "./module/clickData"
import conferencejs from "./module/conferencejs"
import chatChannel from "./module/chatStore"
Vue.use(Vuex)
export default new Vuex.Store({
  plugins:[
    //persistedState({storage:window.sessionStorage})
  ],
  modules:{
    user,
    app,
    websocket, //登陆跳转前链接
    cacheData,
    clickData,
    conferencejs,
    chatChannel
  },
  state:{

  },
  mutations:{

  },
  actions: {

  }

})



// WEBPACK FOOTER //
// ./src/store/index.js